var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"bootstrap-overrides"}},[_c('navbar',{attrs:{"appconfig":_vm.appconfig}}),_vm._v(" "),_c('div',{},[_c('router-view')],1),_vm._v(" "),_c('footer-panel')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }